//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';
import { DEFAULT_DATE_RANGE_FILTER_SECTION } from '@components/media-filters/DateRangeFilter';
import {
  DEFAULT_DISTRIBUTED_TO_FILTER_SECTION,
  DEFAULT_DISTRIBUTION_FILTER_SECTION,
} from '@components/media-filters/DistributionFilter';
import { DEFAULT_MEDIA_TYPE_FILTER_SECTION } from '@components/media-filters/MediaTypeFilter';
import { DEFAULT_ORIENTATION_FILTER_SECTION } from '@components/media-filters/OrientationFilter';
import { DEFAULT_RIGHTS_FILTER_SECTION } from '@components/media-filters/RightsFilter';
import { DEFAULT_SPAM_FILTER_SECTION } from '@components/media-filters/SpamFilter';
import {
  DEFAULT_HASHTAGS_FILTER_SECTION,
  DEFAULT_USERNAMES_FILTER_SECTION,
} from '@components/media-filters/UsernamesHashtagsFilter';
import { DEFAULT_VISUAL_TAGS_FILTER_SECTION } from '@components/media-filters/VisualTagsFilter';
import {
  FilterSection,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { DEFAULT_HAS_LABELS_FILTER_SECTION } from '@content-drawer/filters/LabelsCheckbox';
import { DEFAULT_LABELS_SECTION } from '@content-drawer/filters/LabelsFilter';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export const SELECTED_PRODUCTS_LIMIT = 10;

export const DEFAULT_PRODUCT_TAGS_FILTER_SECTION: FilterSection<boolean> = {
  options: [
    { isSelected: false, label: 'Has product tags', value: true },
    { isSelected: false, label: "Doesn't have product tags", value: false },
  ],
  paramKey: 'hasProducts',
};

export const DEFAULT_HAS_PRODUCTS_FILTER_SECTION: FilterSection<boolean> = {
  options: [
    {
      isSelected: false,
      label: 'No products tagged',
      trackingId: MediaLibraryTrackingIds.PRODUCTS_NOT_TAGGED_CHECKBOX,
      value: false,
    },
    {
      isSelected: false,
      label: 'Product tagged',
      trackingId: MediaLibraryTrackingIds.PRODUCTS_TAGGED_CHECKBOX,
      value: true,
    },
  ],
  paramKey: 'hasProducts',
};

export const DEFAULT_SELECTED_PRODUCTS_FILTER_SECTION: FilterSection<string> = {
  options: [],
  paramKey: 'productIds',
};

export const MediaDefaultFilterSections: Partial<
  Record<MediaFilterParamKey, FilterSection<FilterValue>>
> = {
  dateRange: DEFAULT_DATE_RANGE_FILTER_SECTION,
  distribution: DEFAULT_DISTRIBUTED_TO_FILTER_SECTION,
  hasLabels: DEFAULT_HAS_LABELS_FILTER_SECTION,
  hasProducts: DEFAULT_PRODUCT_TAGS_FILTER_SECTION,
  igHashtags: DEFAULT_HASHTAGS_FILTER_SECTION,
  igUsernames: DEFAULT_USERNAMES_FILTER_SECTION,
  isDistributed: DEFAULT_DISTRIBUTION_FILTER_SECTION,

  labels: DEFAULT_LABELS_SECTION,
  mediaItemTypes: DEFAULT_MEDIA_TYPE_FILTER_SECTION,
  orientation: DEFAULT_ORIENTATION_FILTER_SECTION,
  productIds: DEFAULT_SELECTED_PRODUCTS_FILTER_SECTION,
  rightsStatuses: DEFAULT_RIGHTS_FILTER_SECTION,
  semanticTags: DEFAULT_VISUAL_TAGS_FILTER_SECTION,
  spamFiltering: DEFAULT_SPAM_FILTER_SECTION,
} as const;

export const MediaLibrarySearchTagPrefixes = {
  igHashtags: '#',
  igUsernames: '@',
  semanticTags: '',
} as const;

export const MediaLibrarySearchTagHeaders = {
  igHashtags: 'hashtags',
  igUsernames: 'usernames',
  semanticTags: 'visual tags',
} as const;
